import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import httfront from '../images/TEMPHTT_front.jpg';

import { Row, Col, Container, Image } from 'react-bootstrap';

function Contact() {
    return (
        <div>
            <TopMenu />
            <h2 className='htitleb text-center'>Contact</h2>
            <Container>
                <Row className='justify-content-start'>
                    <Col md={5}>
                        <Image
                            src={httfront}
                            width={'100%'}
                        />
                    </Col>
                    <Col md={7}>
                        <Row>
                            <Col>
                                <h5>Parts Department</h5>
                                7:00am – 4:00pm (808-532-7502) <br /><br />
                                <h5>Truck Sales Department</h5>
                                7:00am - 4:00pm (808-532-7501)
                            </Col>
                            <Col>
                                <h5>Service Department</h5>
                                7:00am - 3:30pm (808-532-7512) <br />
                            </Col>
                        </Row>
                        <br />
                        <hr />
                        <br />
                        <h5>Our Location</h5>
                        <p>
                                311 Pacific Street <br />
                                Honolulu, Hawaii 96817 </p>
                    </Col>


                </Row>
                <br />

            </Container>
            <BottomMenu />
        </div>
    );
}

export default Contact;